<template>
  <Header header__white="header__white" />
  <Breadcrumb title="Hakkımızda" subtitle="Hakkımızda" />
  <AboutArea/>
  <!-- <BannerArea/> -->
  <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Home/Header.vue';
import Breadcrumb from '../components/common/Breadcrumb.vue';
import AboutArea from '../components/common/AboutArea.vue';
// import BannerArea from '../components/Home/BannerArea.vue';
import Footer from '../components/Home/Footer.vue';
import { useSeo } from '@/composables/useSeo';

export default {
    name:'AboutPage',
    components:{
        Header,
        Breadcrumb,
        AboutArea,
        // BannerArea,
        Footer,
    },
    setup() {
        useSeo({
            title: 'Hakkımızda',
            description: 'GelişimP Türkiye olarak alanında uzman psikolog ve psikiyatristlerle online eğitim, seminer ve aile programları düzenliyoruz. Misyonumuz ve uzman kadromuz hakkında detaylar.',
            url: '/about',
            type: 'website'
        })
    }
}
</script>
